// Libraries
import React from 'react';

// Supermove
import {Icon, Popover, Space, Styled} from '@supermove/components';
import {usePopover} from '@supermove/hooks';
import {MilestoneModel} from '@supermove/models';
import {colors} from '@supermove/styles';

// App
import FieldValue from '@shared/design/components/Field/FieldValue';
import IconButton from '@shared/design/components/IconButton';
import Text from '@shared/design/components/Text';

const PopoverContent = Styled.View`
  background-color: ${colors.white};
  border-radius: 8px;
  border: 1px solid ${colors.gray.border};
  padding: 16px;
  min-width: 250px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const AdditionalMilestoneDataPopover = ({milestone}: {milestone: MilestoneModel}) => {
  const popover = usePopover({name: 'Milestone Additional Data'});

  return (
    <React.Fragment>
      <Popover.Content innerRef={popover.ref}>
        <IconButton
          source={Icon.InfoCircle}
          onPress={popover.handleToggle}
          size={16}
          color={colors.gray.secondary}
        />
      </Popover.Content>
      <Popover
        key={popover.key}
        isOpen={popover.isOpen}
        handleOpen={popover.handleOpen}
        handleClose={popover.handleClose}
        reference={popover.ref}
        placement={Popover.Positions.TopEnd}
      >
        <PopoverContent>
          <Text.Subheading>Additional Milestone Data</Text.Subheading>
          <Space height={12} />

          <FieldValue label={'Keywords'} value={milestone.keywords?.join(', ')} />
          <Space height={16} />

          <FieldValue label={'Device'} value={milestone.device} />
          <Space height={16} />

          <FieldValue label={'OS'} value={milestone.os} />
          <Space height={16} />

          <FieldValue label={'Browser'} value={milestone.browser} />
        </PopoverContent>
      </Popover>
    </React.Fragment>
  );
};

export default AdditionalMilestoneDataPopover;
